<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :value="alert" transition="scale-transition" >{{ alert_message }}</v-alert >
    </div>
    <!-- Title-->
    <HeaderComponent :headerTitle="headerText='Pull Back Return Approval'" :router-link="getRouterLink()" :router-link-text="getRouterLinkText()" :return-condition="true" :component-name="componentsName()"/>

    <!-- search-->

    <v-card-title style="padding: 28px 24px 4px 24px;">
      <!-- Search fields -->
      <v-row>
        <v-combobox
          v-model="selected_field"
          :items="field_items"
          item-title="key"
          item-value="key"
          label="Select Field"
          outlined
          style="max-width: 170px;"
        >
        </v-combobox>
        <v-text-field
          class="ml-2"
          prepend-inner-icon="mdi-magnify"
          v-model="search_tag"
          label="Search"
          style="max-width: 180px;"
          outlined
          v-on:keyup.enter="loadData(active_tab)"
        ></v-text-field>

        <v-spacer></v-spacer>
        <v-btn class="ma-2" color="primary" @click="updateReturnPopupDialog()">Update Return window</v-btn>
        <!-- Filter -->
       <v-expansion-panels  class="custom-control_outlined" ref = "filterPopupRef" readonly style="max-width: 300px; margin-bottom: 28px; min-height: 56px;">
        <v-expansion-panel outlined  @click="filterListOfButtons" >
          <v-expansion-panel-header>Filter
            <template v-slot:actions>
              <v-icon color="primary">
                mdi-menu-down
              </v-icon>
            </template>
          </v-expansion-panel-header>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-card-title>
    <v-card-title>
      <v-row>
        <v-col cols="12" sm="6">
          <strong>Pullback Invite ID: PB0546</strong>
        </v-col>
        <v-col cols="12" sm="6">
          <strong>Return Request Validity Period: 01/02/2024 to 25/02/2024</strong>
        </v-col>
      </v-row>
    </v-card-title>

    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-repair" v-model="filterPopup" persistent max-width="1145px">
        <v-card>
          <v-card-actions>
            <v-autocomplete
              v-on:keyup.enter="loadData"
              prepend-inner-icon="mdi-magnify"
              v-model="return_type_search"
              outlined 
              :items="return_types" 
              item-title="original_code"
              item-value="id" 
              label="Return Types"  
                >
            </v-autocomplete>
            <v-text-field prepend-inner-icon="mdi-magnify"  v-model="ra_location_search" label="location"  class="ma-2" outlined></v-text-field>
            <v-text-field prepend-inner-icon="mdi-magnify"  v-model="ra_branch_search" label="branch"  class="ma-2" outlined></v-text-field>
            <v-autocomplete
              v-on:keyup.enter="loadData"
              prepend-inner-icon="mdi-magnify"
              v-model="region_search"
              outlined 
              :items="regions" 
              item-title="original_code"
              item-value="id"
              label="Region" 
                >
            </v-autocomplete>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" class="text-none" color="normal" @click="filterPopup = false">Cancel</v-btn>
            <v-btn size="small" class="text-none" color="primary">Apply Filters(S)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Update Return Window popup -->
    <v-row justify="center">
      <v-dialog v-model="updateReturnPopup" persistent max-width="587px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex">Update Return Window
            <v-spacer></v-spacer> 
            <v-btn icon @click="updateReturnPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0"/>
          <v-card-actions center>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="fromDate"
                  outlined
                  label="From Date"
                  type="date"
                  style="width: 100%;"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="toDate"
                  outlined
                  label="To Date"
                  type="date"
                  style="width: 100%;"
                ></v-text-field>
              </v-col>
            </v-row>
            </v-card-actions>
            <v-card-actions>
              <v-row>
                <v-col style="text-align:center">
                  <v-btn outlined @click="updateReturnPopup = false" >Cancel</v-btn>
                  <v-btn outlined @click="updateReturnSuccessPopup()" >Submit</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Update Return Window Success popup -->
    <v-row justify="center">
      <v-dialog v-model="updateReturnSuccess" persistent max-width="587px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex align-center">Update Return Window
            <v-spacer></v-spacer> 
            <v-btn variant="solo" icon @click="updateReturnSuccess = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider :thickness="4" class="m-0"/>
          <v-card-actions center>
            <v-row>
              <v-col style="text-align:center"><strong>
                Request Id Approved Successfully!</strong>
              </v-col>
            </v-row>
            </v-card-actions>
            <v-card-actions>
              <v-row>
                <v-col style="text-align:center">
                  <v-btn variant="outlined" @click="updateReturnPopup = false , updateReturnSuccess = false" >Ok</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Data Table -->
    <v-layout column>
      <v-flex md6 style="overflow: auto">
        <v-data-table
          :dense="true"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          fixed-header
          height="100%"
          loading-text="Loading Data... Please wait"
          class="elevation-1"
        >
          <template #[`item.approved_quantity`]="{ item }">
                <v-text-field
                v-model="item.approved_quantity"
                outlined
                :rules="[approvedQuantityRule(item.pending_for_approval)]"
                style="width: 200px;"
              ></v-text-field>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!-- pagination display -->
    <div>
      <v-row class="ml-2">
        <v-col cols="4" sm="1" class="PaddingItemPerPage">
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            label="Items per page"
          ></v-select>
        </v-col>
        <span class="item-selected">
          <span v-if="selected.length == 1"
            >{{ selected.length }} Item Selected</span
          >
          <span v-if="selected.length > 1"
            >{{ selected.length }} Items Selected</span
          >
        </span>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="4" class="PaddingItemPerPage">
          <v-pagination
            v-model="page"
            :length="totalPages"
            total-visible="7"
            next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
export default {
  components: {
    HeaderComponent
  },

  data() {
    return {
      headerText: "Pull Back Return Approval",
      alert_type: "success",
      alert: false,
      alert_message: "",
      filterPopup: false,
      loading: false,
      page: 1,
      totalPages: 1,
      pageSize: 100,
      pageSizes: [100, 200, 500],
      search: "",
      search_tag: '',
      selected_field: "",
      active_tab: "",
      table_data: [{"article_id": "td-w56", "article_discription" : "dfdkjhdss", "price": "hfsdfhj", "actual_quantity": "fsefjjbj", "pending_for_approval": '10',"approved_quantity": ''}],
      headers: [],
      updateReturnPopup: false,
      updateReturnSuccess: false,
      fromDate: '',
      toDate: '',
      ra_branch_search: '',
      ra_location_search: '',
      region_search: null,
      return_type_search: '',
      regions: '',
      return_types: '',
      field_items: '',
    };
  },
  async created() {
    this.scrollToTop();
    this.loadData();
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    showAlert(alert_type, alert_message) {
      this.scrollToTop();
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    filterListOfButtons(ev) {
      this.search_tag = '';
      this.filterPopup = true;
      document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    loadData(tab, tab_action) {
      if (tab_action) {
        this.search_tag = "";
        this.selected_field = "";
      }
      this.page = 1;
      this.active_tab = tab;
      this.pageSize = 100;
      this.loading = false;
      this.selected = [];
      this.headers = [
          { text: "Article ID", align: "start", sortable: false, value: "article_id" },
          { text: "Article Discription", value: "article_discription" },
          { text: "Price", value: "price" },
          { text: "Actual Quantity", value: "actual_quantity" },
          { text: "Pending For Approval", value: "pending_for_approval" },
          { text: "Approved Quantity", value: "approved_quantity" },
        ];
    },
    getRouterLink() {
      if (this.headerText === 'Pull Back Return Approval') {
        return { name: 'pull_back_return_approval' };
      }
    },
    getRouterLinkText() {
      if (this.headerText === 'Pull Back Return Approval') {
        return 'PullBack Request';
      }
    },
    componentsName(){
      if (this.headerText === 'Pull Back Return Approval'){
        return 'Article Id';
      }
    },
    approvedQuantityRule(pendingForApproval) {
      return [
        (value) => {
          return !!value || "Approved Quantity is required";
        },
        (value) => {
          if (!value) return true;
          return parseInt(value) <= parseInt(pendingForApproval) || "Approved Quantity must be less than or equal to Pending for Approval";
        },
      ];
    },
    updateReturnPopupDialog(){
      this.updateReturnPopup = true;
    },
    updateReturnSuccessPopup(){
      this.updateReturnSuccess = true;
    }
  }
};
</script>

<style scoped>
.custom-control_outlined button {
  min-height: 56px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.42);
  border-style: solid;
}

  .v-dialog__content:has(.filter-repair){
  justify-content: right;
  align-items: baseline;
  top: 10.5rem;
  }

.item-selected {
  margin-top: 23px;
  position: absolute;
  left: 41%;
}

@media (max-height: 1104px) {
  .PaddingItemPerPage {
    padding: 8px !important;
  }
}

@media (min-height: 1126px) {
  .PaddingItemPerPage {
    padding: 24px !important;
  }
}
</style>
